module.exports = __webpack_public_path__ + "img/logo.adc94f1b.svg";